import styled from 'styled-components';
import { Box, ListItem } from '@mui/material';

export const Container = styled(Box)`
  padding: 24px;
  text-align: center;
  color: white;
`;

export const OfferHeader = styled(Box)`
  margin-bottom: 24px;
`;

export const UrgencyBadge = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 16px;
  border-radius: 20px;
  margin-bottom: 16px;
  backdrop-filter: blur(10px);
`;

export const OfferCard = styled(Box)`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 32px 24px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

export const PriceSection = styled(Box)`
  margin: 24px 0;
  padding: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

export const OriginalPrice = styled(Box)`
  margin-bottom: 8px;
`;

export const DiscountPrice = styled(Box)`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  margin-bottom: 8px;
`;

export const FeaturesList = styled(Box)`
  margin: 24px 0;
  text-align: left;
`;

export const FeatureItem = styled(ListItem)`
  padding: 4px 0;
  color: white;
`;

export const ActionButton = styled(Box)`
  margin-top: 24px;
`;
